import { ProductionColumn } from './production-column';

export class ProductionColumnGroup {
  public id: string;
  public label: string;
  public columns: ProductionColumn[];

  constructor(id: string, label: string, columns?: ProductionColumn[]) {
    this.id = id;
    this.label = label;
    this.columns = columns ?? [];
  }

  add(column: ProductionColumn) {
    this.columns.push(column);
  }

  reset() {
    this.columns.forEach((c) => (c.highlight = false));
  }
}
